// React
import React, { Fragment } from "react";
import PropTypes from "prop-types";

// Libs
import { Table, OverlayTrigger, Tooltip } from "react-bootstrap";

// Utils
import Countries from "../../utils/countries";
import { capitaLetter } from "../../utils/string";

// Components
import Container from "../../component/Container";

// Style
import "./TopProducts.css";

const TopProducts = ({ suppliers }) => {
  const getIsoCountryCode = supplierCountry => {
    let country = Countries.filter(element => {
      return element.name === supplierCountry;
    });

    return country[0].iso_country_code.toLowerCase();
  };

  return (
    <Container style={{ margin: "30px 0 30px 0" }}>
      <Fragment>
        <h1>Your Top Product</h1>
        <Table responsive>
          <thead className="top-products__head">
            <tr>
              <th>Product Image / Name</th>
              <th>Supplier Name</th>
              <th>Orders</th>
              <th>Cost</th>
              <th>Earnings</th>
            </tr>
          </thead>
          <tbody className="top-products__body">
            {suppliers.map((supplier, index) => {
              return (
                <tr key={index}>
                  <td>
                    {index + 1}{" "}
                    <span>
                      <img src={supplier.image} alt={`Product ${index}`} />
                    </span>{" "}
                    <span>{capitaLetter(supplier.title)} </span>
                  </td>
                  <td>
                    {supplier.supplier_name}
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="default-tooltip">
                          {supplier.supplier_country}
                        </Tooltip>
                      }
                    >
                      <span
                        className={`top-products__supplier__flag
                       flag-icon flag-icon-${getIsoCountryCode(
                         supplier.supplier_country
                       )}`}
                      />
                    </OverlayTrigger>
                  </td>
                  <td>{supplier.units_sold}</td>
                  <td>{supplier.total_cost}</td>
                  <td>{supplier.profit_earned}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </Fragment>
    </Container>
  );
};

TopProducts.propTypes = {
  suppliers: PropTypes.array.isRequired
};

export default TopProducts;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/financialDashboard/TopProducts.js